import router from '@/router'
import Vue from 'vue'
import {get, baseUrl } from '@/utils/request';
export default {
    imgSrc(url) { //志愿青春
        if (url) {
            console.log(222, Vue.prototype.$apiUrlZY)
            return Vue.prototype.$apiUrlZY + 'sys/common/static/' + url.split(',')[0]
        } else {
            return require('@/assets/img/youthtop.jpg')
        }
    },
    getTimeDay(time) {
        var str = ''
        if (!time) {
            return str = ''
        }
        // str = time ? time.split(' ')[0].slice(time.split(' ')[0].length - 2, time.split(' ')[0].length) : ''
        str = time.split('-')[2].split(' ')[0]
        return str
    },
    getTimeYM(time) {
        var str = ''
        if (!time) {
            return str = ''
        }
        // str = time ? time.split(' ')[0].slice(0, time.split(' ')[0].length - 3).replaceAll('-', '.') : ''
        var arr = time.split('-');
        str = `${arr[0]}-${arr[1]}`
        return str
    },
    getTopNav(title, type, isPrivate, tier) { //详情页右上角导航信息
        //isPrivate：当前一级页面的私有类型
        //type当前页面分类（前端分类标识）

        var label = title; //一级分类
        var url = '' //一级跳转
        var myPrivate = ''
        var levals = tier ? tier : 1 //几级菜单(1列表，2)
        myPrivate = type == 24 ? isPrivate : type

        if (type == 22 || type == 25 || type == 26) { //工作动态
            label = '工作动态'
            url = '/workNews'
            if (type == 25) { title = '团省委工作动态' }
            if (type == 26) { title = '基层组织工作动态' }
        } else if (type >= 14 && type <= 19 || type == 32) { //党建服务
            label = '党建服务'
            url = '/partyService'
            if (type == 14) { title = '宣传教育' }
            if (type == 15) { title = '专题活动' }
            if (type == 16) { title = '党风廉政' }
            if (type == 17) { title = '党务知识' }
            if (type == 18) { title = '规章制度' }
            if (type == 19) { title = '学习书库' }

            if (type == 32) { title = '试听课件' }
        } else if (type >= 20 && type <= 23 && type != 22) { //聚焦青年
            label = '聚焦青年'
            url = '/focusYouth'
        } else if (type == 24) { //维权服务。isPrivate：当前一级页面的私有类型
            label = '维权服务'
            url = '/Rights'
            if (isPrivate == 3) { title = '维权案例' }
            if (isPrivate == 4) { title = '法律政策' }
            if (isPrivate == 5) { title = '法律维权' }
        } else if (type >= 28 && type < 31) { //志愿青春
            label = '志愿青春'
            url = '/youthVolunteer'
            if (type == 28) { title = '热点新闻' }
            if (type == 29) { title = '全国青年志愿者风采展示' }
            if (type == 30) { title = '个人及青少年风采展示' }
            // if (type == 31) { title = '高校团委动态' }
        }
        //  else if (type == 31) { //高校团委动态
        //     label = '高校团委动态'
        //     url = '/youthVolunteer'
        //     if (type == 31) { title = '高校团委动态' }
        // }
        else if (type > 35 && type<100) { //文件资料
            label = '文件资料'
            title = this.fileInfoType(type);
            url = '/fileInfo'
        }
        // else if (type == 5 || type == 11 || type == 27) { //文件资料
        //     label = '文件资料'
        //     url = '/fileInfo'
        //         // 待修改
        //     if (type == 5) { title = '文件详情' }
        //     if (type == 11) { title = '预决算公开' }
        //     if (type == 27) { title = '青海青少年研究' }

        // }
        else {
            url = '/news' //一级跳转
            if (title.indexOf('详情') != -1) { //详情
                label = title.substr(0, title.length - 2)
            }

        }

        var isList = false
        if (window.location.href.indexOf('/news') != -1) { //当前为列表
            isList = true
        } else { //当前为详情
            isList = false
        }

        var arr = []
        if (levals == 1) { //一级菜单

            arr = [{ label: label, path: url, type: myPrivate }, ]

        } else if (levals == 2) { //二级菜单
            var secondUrl = isList ? '/news' : '/newDetail'
            var secondTit = isList ? title : title + '详情'
            if (type == 1) { //时政要闻》详情
                secondTit = '要闻详情'
            }
            if (type == 7) { //青春风采
                url = '/phoneBooksList'
                secondUrl = ''
            }
            if (type == 19) { //学习书库
                secondUrl = '/studyList'
                secondTit = title
            }
            if (type == 32) { //试听课件
                url = '/listeningTestList'
            }

            if (type > 35 && type<100) { //文件资料
                this.fileInfoID(title);
                // console.log('id', id)
                var id = localStorage.getItem('getClassId')
                secondUrl = id ? '/news?id=' + id : '/news'
            }
            // console.log(router)
            arr = [
                { label: label, path: url, type: myPrivate },
                { label: secondTit, path: secondUrl, type: type, }
            ]

        } else if (levals == 3) { //三级菜单

            var secondUrl = '/news'
            var secondType = type
            var strUrl = '/newDetail'
            if (type == 7) {
                strUrl = 'phoneBooksDetail'
            }
            if (type == 15) { //专题活动
                secondUrl = '/Events'
            }
            if (type == 19) { //学习书库
                secondUrl = '/studyList'
                secondType = 19
            }
            if (type == 32) { //试听课件
                secondUrl = '/listeningTestList'
            }

            if (type > 35 && type<100) { //文件资料
                this.fileInfoID(title);
                var id = localStorage.getItem('getClassId')
                    // console.log('id', id)
                secondUrl = id ? '/news?id=' + id : '/news'
            }
            arr = [
                { label: label, path: url, type: myPrivate },
                { label: title, path: secondUrl, type: secondType },
                { label: title + '详情', path: strUrl, type: type }
            ]

        }

        return arr

    },
    getTopNavZyz(title, type, tier) { //详情页右上角导航信息
        //isPrivate：当前一级页面的私有类型
        //type当前页面分类（前端分类标识）

        var levals = tier ? tier : 1 //几级菜单(1列表，2)

        var label = '志愿青春'
        var url = '/youthVolunteer'

        var isList = false
        if (window.location.href.indexOf('/newsVol') != -1) { //当前为列表
            isList = true
        } else { //当前为详情
            isList = false
        }

        var arr = []
        if (levals == 2) { //二级菜单
            var secondUrl = isList ? '/newsVol' : '/newVolDetail'
            var secondTit = isList ? title : title + '详情'

            arr = [
                { label: label, path: url, type: '' },
                { label: secondTit, path: secondUrl, type: type, }
            ]

        } else if (levals == 3) { //三级菜单

            var secondUrl = '/newsVol'
            var secondType = type
            var strUrl = '/newVolDetail'

            arr = [
                { label: label, path: url, type: '' },
                { label: title, path: secondUrl, type: secondType },
                { label: title + '详情', path: strUrl, type: type }
            ]

        }

        return arr

    },
    goPage(url, type, id, title) {
        this.goTop()
        var val = type ? url + '?type=' + type : url
        var params = {}
        if (type) {
            params.type = type
        }
        if (id) {
            params.id = id
        }
        if (title) {
            params.title = title
        }
        router.push({
            path: url,
            query: params
        })

    },
    overfElli(str, len) {
        var strings = ''
        if (str) {
            str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "")
                .replace(/&ldquo;/gi, "").replace(/\n/gi, "").replace(/\&rdquo;/gi, '');
            if (str.length <= len) {
                strings = str
            } else {
                strings = str.slice(0, len) + '...'
            }
        } else {
            strings = ''
        }

        return strings
    },
    regImg(newContent) { //富文本图片处理
        if (newContent) {
            newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%; width:100%;height:auto;display:block;margin:10rpx auto;"');
            newContent = newContent.replace(/\<video/gi, '<video style="max-width:100%; width:100%;height:auto;display:block;margin:10rpx auto;"');
            // newContent = newContent.replace(/\&rdquo;/gi, '');
            if (newContent.indexOf('<table') != -1) {
                newContent.replace(/\<table/gi, '<table borer="1"')
            }

        }

        return newContent;
    },
    goTop() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        document.getElementsByClassName('layout')[0].scrollTop = 0
    },
    getTitle(type) { //* 暂未使用
        var title = ''
        switch (type * 1) {
            case 1:
                title = '时政要闻' //
                break;
            case 2:
                title = '公示公告' //
                break;
            case 3:
                title = '工作动态' //*停用
                break;
            case 4:
                title = '聚焦青年' //*停用
                break;
            case 5:
                title = '文件资料'
                break;
            case 6:
                title = '专题活动'
                break;
            case 7:
                title = '青春风采'
                break;
            case 8:
                title = '省级团委动态'
                break;
            case 9:
                title = '市州县级团委动态'
                break;
            case 10:
                title = '县级团委动态'
                break;

            case 11: //分类到：文件资料
                title = '预决算公开'
                break;
            case 12:
                title = '优秀五四青年'
                break;
            case 13:
                title = '优秀团干部'
                break;
            case 14:
                title = '宣传教育' //党建服务》
                break;
            case 15:
                title = '活动专题' //党建服务》
                break;
            case 16:
                title = '党风廉政' //党建服务》
                break;
            case 17:
                title = '党务知识' //党建服务》
                break;
            case 18:
                title = '规章制度' //党建服务》
                break;
            case 19:
                title = '学习书库' //党建服务》
                break;
            case 20:
                title = '青年大学习' //聚焦青年》
                break;
            case 21:
                title = '青年发展规划' //聚焦青年》
                break;
            case 22:
                title = '媒体聚焦' //*停用
                break;
            case 23:
                title = '青年说' //聚焦青年》
                break;
            case 24:
                title = '维权服务'
                break;
            case 25: //所属于：工作动态
                title = '团省委工作动态'
                break;
            case 26: //所属于：工作动态
                title = '基层组织工作动态'
                break;
            case 27: //所属于：文件资料
                title = '青海青少年研究' //取消了
                break;
            case 28: //所属于：青年志愿者-志愿青春
                title = '热点新闻'
                break;
            case 29: //所属于：青年志愿者-志愿青春
                title = '全国青年志愿者风采展示'
                break;
            case 30: //所属于：青年志愿者-志愿青春
                title = '个人及青少年风采展示'
                break;
            case 31:
                title = '高校团委动态'
                break;
            case 32: //所属于：党建服务-试听课件
                title = '试听课件'
                break;
            case 33: //首页
                title = '学联之窗'
                break;
            case 34: //首页
                title = '少先队工作'
                break;
            case 35: //首页
                title = '创业活动'
                break;
            case 101: //首页
                title = '企业团委动态'
                break;
            case 102: //首页
                title = '少先队动态'
                break;
            case 103: //首页
                title = '青年创业'
                break;
        }
        if (type > 35 && type < 100) {
            title = '文件资料'
        }
        return title
    },
    getDetailTitle(type) {
        var title = ''
        switch (type * 1) {
            case 1:
                title = '时政要闻' //
                break;
            case 2:
                title = '公告' //
                break;
            case 3:
                title = '工作动态' //*停用
                break;
            case 4:
                title = '聚焦青年' //*停用
                break;
            case 5:
                title = '资料'
                break;
            case 6:
                title = '活动' //
                break;
            case 7:
                title = '青春风采' //
                break;
            case 8:
                title = '省级团委动态' //
                break;
            case 9:
                title = '市州县级团委动态' //
                break;
            case 10:
                title = '县级团委动态' //
                break;

            case 11:
                title = '预决算公开' //
                break;
            case 12:
                title = '优秀五四青年' //
                break;
            case 13:
                title = '优秀团干部' //
                break;
            case 14:
                title = '宣传教育' //党建服务》
                break;
            case 15:
                title = '活动专题' //党建服务》
                break;
            case 16:
                title = '党风廉政' //党建服务》
                break;
            case 17:
                title = '党务知识' //党建服务》
                break;
            case 18:
                title = '规章制度' //党建服务》
                break;
            case 19:
                title = '学习书库' //党建服务》
                break;
            case 20:
                title = '青年大学习' //聚焦青年》
                break;
            case 21:
                title = '青年发展规划' //聚焦青年》
                break;
            case 22:
                title = '媒体聚焦' //*停用
                break;
            case 23:
                title = '青年说' //聚焦青年》
                break;
            case 24:
                title = '维权案列' //
                break;
            case 25: //所属于：工作动态
                title = '团省委工作动态'
                break;
            case 26: //所属于：工作动态
                title = '基层组织工作动态'
                break;
            case 27: //所属于：文件资料
                title = '青海青少年研究' //取消了
                break;
            case 28: //所属于：青年志愿者-志愿青春
                title = '热点新闻'
                break;
            case 29: //所属于：青年志愿者-志愿青春
                title = '全国青年志愿者风采展示'
                break;
            case 30: //所属于：青年志愿者-志愿青春
                title = '个人及青少年风采展示'
                break;
            case 31:
                title = '高校团委动态' //
                break;
            case 32: //所属于：党建服务-试听课件：新增
                title = '试听课件'
                break;
            case 33: //首页
                title = '学联之窗'
                break;
            case 34: //首页
                title = '少先队工作'
                break;
            case 35: //首页
                title = '创业活动'
                break;
            case 101: //首页
                title = '企业团委动态'
                break;
            case 102: //首页
                title = '少先队动态'
                break;
            case 103: //首页
                title = '青年创业'
                break;
        }
        if (type > 35 && type < 100) {
            title = this.fileInfoType(type)
        }
        return title
    },
    async getDict(type, dictName) {
        var arr = []
        await get('/sys/dict/getDictItems/' + type).then(res => {
            arr = res.result;
            if (dictName) {
                localStorage.setItem(dictName, arr ? JSON.stringify(arr) : [])
            }

        })
        return arr
    },
    async fileInfoID(title) {
        var arr1 = localStorage.getItem('dictStudy') ? JSON.parse(localStorage.getItem('dictStudy')) : [];
        var arr2 = localStorage.getItem('dictFile') ? JSON.parse(localStorage.getItem('dictFile')) : [];
        var id = ''
        if (!localStorage.getItem('dictStudy')) {
            arr1 = await this.getDict('study_type', 'dictStudy')
        }

        if (!localStorage.getItem('dictFile')) {
            arr2 = await this.getDict('file_type', 'dictFile');
        }

        if (arr1.length > 0) {
            arr1.forEach(k => {
                if (k.title == title) {
                    id = k.value
                }
            })
        }
        if (arr2.length > 0) {
            arr2.forEach(k => {
                if (k.title == title) {
                    id = k.value
                }
            })
        }
        // console.log('getid', id)
        localStorage.setItem('getClassId', id)
        return id
    },
    fileInfoType(type) {
        var title = ''
        var arr = [
            { title: '青团函', type: 36 },
            { title: '青团发', type: 37 },
            { title: '青团', type: 38 },
            { title: '青团联发', type: 39 },
            { title: '青团办', type: 40 },
            { title: '青团办通报', type: 41 },
            { title: '青团办内通', type: 42 },
            { title: '其他', type: 43 },
            { title: '讲话', type: 44 },
            { title: '新思想', type: 45 },
            { title: '理论', type: 46 },
            { title: '重要论述', type: 47 },
            { title: '团史百科', type: 48 },
        ]
        var index = arr.findIndex(k => { return k.type == type })
        if (index > -1) {
            title = arr[index].title
        }
        return title
    },
    browserType() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
        var isEdge = userAgent.indexOf("Windows NT 6.1; Trident/7.0;") > -1 && !isIE; //判断是否IE的Edge浏览器
        var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
        var isSafari = userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
        var isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

        if (isIE) {
            return "IE"
                // var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                // reIE.test(userAgent);
                // var fIEVersion = parseFloat(RegExp["$1"]);
                // if (fIEVersion == 7) { return "IE7"; } else if (fIEVersion == 8) { return "IE8"; } else if (fIEVersion == 9) { return "IE9"; } else if (fIEVersion == 10) { return "IE10"; } else if (fIEVersion == 11) { return "IE11"; } else { return "0" } //IE版本过低
        } //isIE end

        if (isFF) { return "FF"; }
        if (isOpera) { return "Opera"; }
        if (isSafari) { return "Safari"; }
        if (isChrome) { return "Chrome"; }
        if (isEdge) { return "Edge"; }
    }
}
